/**
 * YazioMealsPage - Router wrapper for Yazio Meal Logging
 * Provides data and renders the meal logging content
 */

import React from "react";

import { YazioMealLoggingTab } from "../organisms/YazioMealLoggingTab";

export const YazioMealsPage: React.FC = () => {
  return <YazioMealLoggingTab />;
};
